import { Component, SimpleChanges, OnInit, OnChanges, ViewChild, ViewContainerRef, ComponentFactoryResolver, Input, Output, EventEmitter } from '@angular/core';
import { EFormSection } from './section';

@Component({
    selector: 'eform-page',
    templateUrl: './page.html',
    // template: `
    // <h3>{{layout?.title || layout?.heading}}</h3>
    // <div #page></div>
    // `,
    styleUrls: ['./page.scss']
  })
export class EFormPage implements OnInit, OnChanges {

    @Input('layout')
    layout: any;

    // @Input('showTitle')
    // showTitle: boolean = true;

    @Output('change')
    onChange: EventEmitter<{name: string, value: any}> = new EventEmitter<{name: string, value: any}>();

    @ViewChild('page', {static: true, read: ViewContainerRef})
    page: ViewContainerRef;

    constructor(private componentFactoryResolver: ComponentFactoryResolver) {}

    ngOnInit() {
        this.load();
    }

    ngOnChanges(changes : SimpleChanges) {
        this.load();
    }

    load() {
        if (!this.page) return;

        this.page.clear();

        if (this.layout && this.layout.sections) {
            for(let section of this.layout.sections) {
                this.createSection(section, this.page);
            }
        }
    }

    createSection(section: any, parent: ViewContainerRef) {
        const sectionFactory = this.componentFactoryResolver.resolveComponentFactory(EFormSection);
    
        const sectionRef = parent.createComponent(sectionFactory);
        sectionRef.instance.layout = section;
        // console.log('Created section', sectionRef);
        sectionRef.instance.onChange.subscribe({
            next: (change: {name: string, value: any}) => {

                if (this.layout.target) {
                    this.layout.target[change.name] = change.value;
                }
                this.onChange.emit(change);
            }
        });        
    }
}